import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Cookies from 'js-cookie'
//引入全局css文件
import '@/assets/css/main.css';

//引入路由控制文件
import '@/permission.js';

// 引入axios
import axios from '@/util/request'
Vue.prototype.axios = axios

Vue.config.productionTip = false

//引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//默认element尺寸
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'small', // set element-ui default size
    //locale: enLang // 如果使用中文，无需设置，请删除
})

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);


import utils from './util/util';
Vue.prototype.utils = utils


window.$vue = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
